import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { routes } from '../config/routes.config';
import { ChaosTableGet, ChaosTableGetResponse } from './types/chaos-table-list.dto';
import {
   AddRowDto,
   CloseRowDto,
   EditRowDto,
   EnrollmentLinkDto,
   JoinRowsDto,
   PossibleRowDuplicate,
   PossibleRowDuplicatesDto,
   ReminderEmailDto
} from './types/chaos-table.dto';
import { ChaosTableHistoryRow } from './types/chaos-table-history-row';
import { ChaosTableHistoryGetDto } from './types/chaos-table-get-history.dto';
import { ChaosTableRow } from './types/chaos-table-row.interface';

@Injectable({
   providedIn: 'root'
})
export class ChaosTableService {
   // eslint-disable-next-line no-unused-vars
   constructor(private httpClient: HttpClient) {}

   list(data: ChaosTableGet): Observable<ChaosTableGetResponse> {
      return this.httpClient.post<ChaosTableGetResponse>(routes.chaosTableList, data);
   }

   addNewRow(data: AddRowDto): Observable<void> {
      return this.httpClient.post<void>(routes.chaosTable, data);
   }

   editRow(data: EditRowDto): Observable<void> {
      return this.httpClient.patch<void>(routes.chaosTable, data);
   }

   sendEnrollmentLink(data: EnrollmentLinkDto): Observable<HttpResponse<ChaosTableRow>> {
      return this.httpClient.post<ChaosTableRow>(routes.chaosTableEnrollment, data, {
         observe: 'response'
      });
   }

   sendReminderLink(data: ReminderEmailDto): Observable<HttpResponse<ChaosTableRow>> {
      return this.httpClient.post<ChaosTableRow>(routes.chaosTableReminder, data, {
         observe: 'response'
      });
   }

   closeRow(data: CloseRowDto): Observable<HttpResponse<void>> {
      return this.httpClient.delete<void>(routes.chaosTable, {
         body: { ...data },
         observe: 'response'
      });
   }

   joinRows(data: JoinRowsDto): Observable<void> {
      return this.httpClient.post<void>(routes.chaosTableJoinRows, data);
   }

   listPossibleRowDuplicates(data: PossibleRowDuplicatesDto): Observable<PossibleRowDuplicate[]> {
      return this.httpClient.get<PossibleRowDuplicate[]>(routes.chaosTableJoinRows, {
         params: { ...data }
      });
   }

   getHistory(
      data: ChaosTableHistoryGetDto
   ): Observable<{ list: ChaosTableHistoryRow[]; count: number }> {
      return this.httpClient.post<{ list: ChaosTableHistoryRow[]; count: number }>(
         routes.chaosTableHistory,
         data
      );
   }

   uploadXLSX(file: File): Observable<any> {
      const formData = new FormData();
      formData.append('uploads', file);
      return this.httpClient.post(routes.chaosTableExcel, formData);
   }
}
